module.exports = __webpack_public_path__ + "img/mark.a27a8701.png";